import { ExternalUser, SalesPerson } from "models/customers/customers";

export function userExistsOnCustomer(
  externalUsers: ExternalUser[],
  internalUsers: SalesPerson[],
  user: Partial<ExternalUser>
) {
  // Check for existing users (case-insensitive email or matching SSN)
  const externalUserOnCustomer = externalUsers.filter(
    (eu) =>
      (user.email && eu.email && eu.email.toLowerCase() === user.email.toLowerCase()) ||
      (user.socialSecurityNumber && eu.socialSecurityNumber && eu.socialSecurityNumber === user.socialSecurityNumber)
  );
  const internalUserOnCustomer = internalUsers.filter(
    (iu) =>
      (user.email && iu.email && iu.email.toLowerCase() === user.email.toLowerCase()) ||
      (user.socialSecurityNumber && iu.socialSecurityNumber && iu.socialSecurityNumber === user.socialSecurityNumber)
  );

  const isNewUser =
    externalUserOnCustomer.length === 0 && internalUserOnCustomer.length === 0;

  return !isNewUser;
}
